<nb-card>
  <nb-card-body>
    <div class="dl-label">
      {{ "Downloading" | translate }}
    </div>
    <div class="dl-icon">
      <fa-icon icon="circle-notch" [spin]="true" size="lg" class="fa-spin"></fa-icon>
    </div>
  </nb-card-body>
</nb-card>
